<template>
  <header class="flex items-center justify-between gap-4">
    <span class="font-size-5 font-500 line-height-8 tracking-[0.25px]">
      {{ t('canvasUI.pptConversionSelector.title', { count: allSlidesCount }) }}
    </span>

    <CButton class="rounded h-11 w-11" @click="emit('cancel')">
      <template #icon>
        <CIcon icon="close" size="16" />
      </template>
    </CButton>
  </header>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import CButton from '@lib/components/CButton/CButton.vue'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import { useAppStore } from '@ppt-conversion-selector/stores/app.store'
import { getAllSlidesCount } from '@ppt-conversion-selector/utils/data.util'

const emit = defineEmits<{
  close: []
  cancel: []
}>()

const { t } = useI18n()
const { collection } = useAppStore()
const allSlidesCount = computed(() => getAllSlidesCount(collection.value))
</script>
